import { useEffect, useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { privateRoutes } from "routes/PrivateRoute";

function PageHeader() {
  const routes = useRouteMatch();
  const [heading, setHeading] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    let page = privateRoutes?.find((p) => p?.path == routes?.path);

    setHeading(page?.name);
    setDescription(page?.description);
  }, []);

  return (
    <div className="flex flex-row bg-white items-start justify-between pt-2 border-b-2 border-solid border-neutral-200 px-6 py-4">
      <div className="md:w-8/12 relative">
        <h1
          style={{ color: "var(--Dawn-700, #CE5511)" }}
          className={`text-2xl hidden md:flex flex-row items-center text-left font-semibold font-karla tracking-tight text-primary-gray-1000`}
        >
          <p>{heading} </p>
        </h1>
      </div>
    </div>
  );
}

export default PageHeader;
